import cx from 'classnames';
import { TradeStatus } from '@/common/TradeCard/constants';
import { FinanceStatus } from './FinanceCard/constants';

const statusStyles: Record<TradeStatus | FinanceStatus, string> = {
  Active: 'border-green-2 text-blue-6',
  Expired: 'bg-red-2 border-red-2 text-white h-20',
  ExpiringSoon: 'border-yellow-2 text-blue-6',
  HighNet: 'border-blue-5 text-blue-6',
  Pending: 'border-blue-5 text-blue-6',
  SoftPull: 'border-green-2 text-blue-6',
  None: ''
};

type OwnPros = {
  status: TradeStatus | FinanceStatus;
  text: string | null;
};

export default function StatusIndicator({ status, text }: OwnPros) {
  if (status === TradeStatus.None) return null;

  return (
    <div
      className={cx(
        'flex h-24 items-center rounded-xl border-2 px-lg text-center !font-bold tl-body-xs',
        statusStyles[status]
      )}
      data-qa="status-badge"
    >
      <span data-qa="status-badge-text">{text}</span>
    </div>
  );
}
